import styled from "styled-components";

import { color, fontFamily, fontSize, spacingDefaults } from "style/constants";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacingDefaults.normal};
  text-align: center;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Heading = styled.h2`
  font-family: ${fontFamily.secondary};
  font-size: ${fontSize.large};
  margin-bottom: 0;
`;

export const Score = styled.div`
  color: ${color.DARKBLUE};
  font-family: ${fontFamily.primary};
  font-size: ${fontSize.xxlarge};
  font-weight: 700;
`;

export const Explanation = styled.p`
  color: ${color.BLACK};
  font-family: ${fontFamily.primary};
  font-size: ${fontSize.medium};
  margin: 0;
  margin-bottom: ${spacingDefaults.normal};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacingDefaults.small};
  margin-top: ${spacingDefaults.xlarge};
  width: 100%;
  max-width: 265px;

  button {
    width: 100%;
    height: 40px;
    padding: 0 ${spacingDefaults.normal};
  }
`;
